import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html';

import s from 'components/bolt/burgerMenu/burgerMenu.sss';

export default class BurgerMenu extends Component {

	render(props) {
		const {
			type,
			style,
			lineStyle,
			dark,
			hidden,
			showtimesOverlayOpen,
			homeEntOverlayOpen,
			pressKitOverlayOpen,
			widgetFullyExpanded,
			navOpen,
			homeScrolled,
			isSinglePageIframed,
			showtimesSearchOverlay,
			videoOverlayOpen,
			oneSheetOverlay,
			oneSheetOverlayOpen,
			trailerOverlayOpen,
			trailerOverlay,
			calendarRemind,
			calendarRemindOpen,
			extraClass,
			customBurgerMenu
		} = props;

		return (
			<div
				class={joinClasses(
					s.container,
					s[type],
					dark && s.dark,
					(showtimesOverlayOpen || widgetFullyExpanded) && s.showtimes,
					homeEntOverlayOpen && s.homeEnt,
					pressKitOverlayOpen && s.pressKit,
					navOpen && s.navOpen,
					homeScrolled && s.homeScrolled,
					(isSinglePageIframed || hidden) && s.hidden,
					showtimesSearchOverlay && s.searching,
					videoOverlayOpen && s.video,
					oneSheetOverlay && s.oneSheetOverlay,
					oneSheetOverlayOpen && s.oneSheetOverlayOpen,
					trailerOverlayOpen && s.trailerOverlayOpen,
					trailerOverlay && s.trailerOverlay,
					calendarRemindOpen && s.calendarRemindOpen,
					calendarRemind && s.calendarRemind,
					customBurgerMenu && s.customBurgerMenu,
					extraClass
				)}
				style={style}
			>
				{!customBurgerMenu?.icon ? (
					<div>
						<div style={lineStyle} class={s.line} />
						<div style={lineStyle} class={s.line} />
						<div style={lineStyle} class={s.line} />
					</div>
				) : (
					<HTML tag="div" markdown>{customBurgerMenu?.icon}</HTML>
				)}
			</div>
		);
	}
}
